import { setTrackingId } from "client/Misc/utils";
import {
	ReactElement,
	Ref,
	forwardRef,
	useMemo
} from "react";

type NativeReactIFrameProps = React.DetailedHTMLProps<React.IframeHTMLAttributes<HTMLIFrameElement>, HTMLIFrameElement>;

export type IFrameProps = Omit<NativeReactIFrameProps, "sandbox" | "ref"> & {
	trackingId: string;
	permissions: readonly IFramePermission[];
};

export const IFrame = forwardRef(
	(props: IFrameProps, ref: Ref<HTMLIFrameElement>): ReactElement => {
		const {
			trackingId,
			permissions,
			...otherProps
		} = props;

		const sandbox = useMemo(
			(): string => computeSandboxValue(permissions),
			[permissions]
		);

		return (
			<iframe
				{...otherProps}
				{...setTrackingId(trackingId)}
				ref={ref}
				sandbox={sandbox}
			/>
		);
	}
);
IFrame.displayName = "IFrame";

export function computeSandboxValue(permissions: readonly IFramePermission[]): string {
	return permissions.join(" ");
}

export enum IFramePermission {
	Downloads ="allow-downloads",
	Forms = "allow-forms",
	Modals = "allow-modals",
	OrientationLock = "allow-orientation-lock",
	PointerLock = "allow-pointer-lock",
	Popups = "allow-popups",
	EscapingPopups = "allow-popups-to-escape-sandbox",
	Presentation = "allow-presentation",
	SameOrigin = "allow-same-origin",
	Scripts = "allow-scripts",
	TopNavigation = "allow-top-navigation",
	TopNavigationByUser = "allow-top-navigation-by-user-activation",
	TopNavigationToCustomProtocol = "allow-top-navigation-to-custom-protocols"
}

export const allPermissions: readonly IFramePermission[] = Object.values(IFramePermission);
